import React, { Component } from 'react'
import { Form, Input, Button, AutoComplete, Icon } from 'antd'
import styled from 'styled-components'
import { convertNamesToOption } from '../util'

const FormItem = Form.Item
const propTypes = {}
const AddItemArea = styled.div`
  padding: 15px;
  background-color: #f7f7f7;
`

class CreateAddressForm extends Component {
  handleCreate = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }

      this.props.addContact(values.contact)
    })
  }
  render() {
    const { getFieldDecorator } = this.props.form
    const { contentData, allContacts } = this.props
    return (
      <div className="addressForm">
        <AddItemArea>
          <Form layout="vertical">
            <div className="row">
              <div className="col-md-12">
                <FormItem label="Contact">
                  {getFieldDecorator('contact', {
                    rules: [
                      {
                        required: true,
                        message: 'Find your contact'
                      }
                    ],
                    initialValue: contentData ? contentData.contact : ''
                  })(
                    <AutoComplete
                      dataSource={convertNamesToOption(allContacts)}
                      style={{ width: 320 }}
                      filterOption={(inputValue, option) =>
                        option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                      }
                      placeholder="Search for a contact"
                    >
                      <Input suffix={<Icon type="search" className="certain-category-icon" />} />
                    </AutoComplete>
                  )}
                </FormItem>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <Button onClick={() => this.handleCreate()}>Add contact</Button>
              </div>
            </div>
          </Form>
        </AddItemArea>
      </div>
    )
  }
}

CreateAddressForm.propTypes = propTypes
export default Form.create()(CreateAddressForm)



// WEBPACK FOOTER //
// ./src/components/SelectExistingContact.js